import {NgModule, StaticProvider} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {downgradeModule} from '@angular/upgrade/static';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {CommonsModule} from '../../commons/angular/commons.module';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {ServicePointSelectComponent} from './components/service-point-select/service-point-select.component';
import {ServicePointSelectListComponent} from './components/service-point-select-list/service-point-select-list.component';

@NgModule({
  declarations: [
    ServicePointSelectComponent,
    ServicePointSelectListComponent
  ],
  imports: [
    BrowserModule,
    CommonsModule,
    ScrollingModule,
    TranslateModule,
    FormsModule,
  ],
  providers: [],
  exports: [
    ServicePointSelectComponent,
    ServicePointSelectListComponent
  ]
})
export class ServicePointsModule {
  constructor() {
  }

  ngDoBootstrap() {
  }
}

const bootstrapServicePointsModule = (extraProviders: StaticProvider[]) => {
  const platformRef = platformBrowserDynamic(extraProviders);
  return platformRef.bootstrapModule(ServicePointsModule);
};

export const downgradedServicePointsModule = downgradeModule(bootstrapServicePointsModule);
